module.exports = __webpack_public_path__ + "img/green-arrow.0be95a11.svg";